export default __webpack_public_path__ + "574cc24007cf3abedad0559183f307e0.svg";